import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Automation",
    subheader:
      "Use Stripe webhook events to automate any task and extract checkout related data."
  }),
  rows: [
    {
      title: {
        value: "All Stripe webhook events",
        tooltip:
          "Listen to and trigger any action based on Stripe webhook events."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Custom Zapier integration",
        tooltip:
          "Use our Zapier integration to extract additional checkout information, captured custom form data and more."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
